/* Preferred · Shop grid (ELIJDEV): filter drawer + sort */
(function () {
  function init(root) {
    if (root.dataset.pfReady) return;
    root.dataset.pfReady = '1';
    var dialog = root.querySelector('[data-pf-filters]');
    var opener = root.querySelector('[data-pf-open-filters]');
    if (dialog && opener) {
      opener.addEventListener('click', function () { dialog.showModal(); document.documentElement.classList.add('pf-lock'); });
      dialog.addEventListener('close', function () { document.documentElement.classList.remove('pf-lock'); opener.focus(); });
      var closer = root.querySelector('[data-pf-close-filters]');
      if (closer) closer.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
    var sort = root.querySelector('[data-pf-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  function all() { document.querySelectorAll('.pf-shop').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();